(ns hai.tags.routes
  (:require
   [hai.tags.page :as page]
   [hai.ui.icons :as icons]
   [hai.web-app.routing :as routing]))

(defn routes []
  [["/tags"
    {::routing/window-title "Tags"
     :label "Tags"
     :icon (icons/mui-icon :outlined :label)}
    [""
     {:name :tags/view
      :view page/page}]]])
